const route = '/api/send-metrics';

const sendMetric = (metrics = {}, clickedUrl = '#') => {
	const token = document.querySelector('meta[name="csrf-token"]');

	if (token) {
		fetch(route, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': token.content
			},
			body: JSON.stringify(metrics)
		})
		.then(response => {
			if (response.ok) {
				window.location.href = clickedUrl;
			} else {
				console.log('sendMetric response: ', response);
				window.location.href = clickedUrl;
			}
		})
		.catch(error => {
			console.error('sendMetric error: ', error);
			window.location.href = clickedUrl;
		})
	} else {
		console.log("sendMetric: X-CSRF-TOKEN is missing");
		window.location.href = clickedUrl;
	}
};

export const customSendMetric = (metrics = {}, clickedUrl = '#') => {
	const token = document.querySelector('meta[name="csrf-token"]');
	
	if (token) {
		fetch(route, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': token.content
			},
			body: JSON.stringify(metrics)
		})
		.then(response => {
			if (response.ok) {
				window.location.href = clickedUrl;
			} else {
				console.log('customSendMetric response: ', response);
				window.location.href = clickedUrl;
			}
		})
		.catch(error => {
			console.error('customSendMetric error: ', error);
			window.location.href = clickedUrl;
		})
	} else {
		console.log("customSendMetric: X-CSRF-TOKEN is missing");
		window.location.href = clickedUrl;
	}
};

export const sendMetricAsync = (metrics = {}, path = route) => {
	const token = document.querySelector('meta[name="csrf-token"]');

	if (token) {
		fetch(path, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': token.content
			},
			body: JSON.stringify(metrics)
		})
		.then(response => {
			if (!response.ok) {
				console.log('sendMetricAsync response: ', response);
			}
		})
		.catch(error => {
			console.error('sendMetricAsync error: ', error);
		})
	} else {
		console.log("sendMetricAsync: X-CSRF-TOKEN is missing");
	}
};

let debounceTimeout;

export const clickTracker = () => {
	const targetElements = Array.from(new Set([
		...document.querySelectorAll('[data-metric-ab-tower]'),
		...document.querySelectorAll('[data-metric-data-dog]')
	]));

	targetElements.forEach(element => {
		if (element.getAttribute('for') === 'fileElem' ||
			element.hasAttribute('data-formid') ||
			element.parentElement.hasAttribute('data-formid')
		) {
			element.addEventListener('click', e => {
				clearTimeout(debounceTimeout);
				
				const attributes = {};
				const abTower = e.currentTarget.getAttribute('data-metric-ab-tower');
				const dataDog = e.currentTarget.getAttribute('data-metric-data-dog');
	
				if (abTower) {attributes.abTower = abTower};
				if (dataDog) {attributes.dataDog = dataDog};
	
				debounceTimeout = setTimeout(() => {
					sendMetricAsync(attributes);
				}, 300);
			});
		} else {
			element.addEventListener('click', e => {
				e.preventDefault();
				clearTimeout(debounceTimeout);

				let clickedUrl;

				if (e.currentTarget.hasAttribute('href')) {
					clickedUrl = e.currentTarget.getAttribute('href');
				} else if (e.currentTarget.parentElement.hasAttribute('href')) {
					clickedUrl = e.currentTarget.parentElement.getAttribute('href');
				} else {
					console.log('clickTracker: no link to redirect');
				}

				const attributes = {};
				const abTower = e.currentTarget.getAttribute('data-metric-ab-tower');
				const dataDog = e.currentTarget.getAttribute('data-metric-data-dog');
	
				if (abTower) {attributes.abTower = abTower};
				if (dataDog) {attributes.dataDog = dataDog};
	
				debounceTimeout = setTimeout(() => {
					sendMetric(attributes, clickedUrl);
				}, 300);
			});
		}
	});	
};